import * as React from 'react';
import { useState, useEffect, useRef } from 'react';

/** Material UI Packages. */
import { Paper } from '@mui/material';

import Draggable from 'react-draggable';

export function PaperComponent(props) {
    const nodeRef = useRef(null);
    return (
        <Draggable nodeRef={nodeRef} handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} ref={nodeRef} />
        </Draggable>
    );
}
